import React, { Component } from 'react';
import { Button, Row, Col, Table, Popconfirm, Select, Pagination, Checkbox, Modal, Card } from 'antd';
import Carousel from 'react-slick';
import PropTypes from 'prop-types';
import { api, app, config } from '../../../app';
import utils from '../../../utils';
import _ from 'underscore';
import common from '../common2';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Option = Select.Option;

class RIzzzzr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_loading: true,
      selectedRowKeys: [],
      auditList: [],
      total: 0,
      page: 1,
      dataType: '1',
      detail_visible: false,
      detail_info: {},
      detail_img: {
        flag: 0,
        img: '',
      },
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = async (data) => app.setStateSync(this, data);

  componentDidMount() {
    this._isMounted = true;
    this.dataSource();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 数据源
   */
  dataSource = async (page = 1) => {
    await this.setData({ page, data_loading: true });
    let { dataType } = this.state, params = {
      page,
      type: dataType,
      indexno: app.getData('indexno'),
      account: app.getData('account'),
    };
    let { flag, data, msg, total } = await app.post(api.InsuraOrgAuditLists, params);
    if (flag !== 1) {
      app.alert(msg, 'error');
      data = [];
    }
    if (page === this.state.page) {
      await this.setData({
        selectedRowKeys: [],
        data_loading: false,
        auditList: utils.addArrayKey(data),
        total: parseInt(total || 0),
      });
    }
  };

  /**
   * 页码修改
   * @param page
   */
  handlePageChange = async (page) => {
    await this.dataSource(page);
  };

  /**
   * 全选
   * @param e
   * @returns {Promise<void>}
   */
  handleAllSel = async (e) => {
    let checked = e.target.checked;
    let selectedRowKeys = [];
    if (checked) {
      selectedRowKeys = _.range(1, this.state.auditList.length + 1);
    }
    await this.setData({ selectedRowKeys });
  };

  /**
   * 批量审核
   * @param type
   */
  handlePLReview = async (type) => {
    let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length;
    if (len === 0) {
      app.alert('请选择审核内容', 'warn');
      return;
    }
    let tp = parseInt((total - len) / 20);
    tp = (total - len) % 20 === 0 ? tp : tp + 1;
    if (tp >= page) {
      tp = page;
    }
    let id = selectedRowKeys.map(index => auditList[index - 1].id).join(',');
    let reviewInfo = {
      id,
      uri: api.InsuraOrgAudit,
      id_key: 'id',
      source: () => this.dataSource(tp),
    };
    if (type === 1) {
      this.props.successReview(1, '', reviewInfo);
    } else if (type === 2) {
      this.props.failReview(reviewInfo);
    }
  };

  /**
   * 搜索
   * @param search_type
   * @param search_val
   */
  handleSearch = async (search_type, search_val) => {
    await this.setData({ search_type, search_val });
    await this.dataSource();
  };

  /**
   * 打开详情
   * @param item
   */
  handleOpenDetail = async (item) => {
    item.img = item.img || [];
    await this.setData({ detail_visible: true, detail_info: item });
    this.handleDetailImg(item.img.length ? item.img[0] : false, 0);
  };

  /**
   * 详情图片
   * @param img
   * @param index
   */
  handleDetailImg = async (img, index) => {
    const src = config.imgUrl + img;
    await this.setData({ detail_img: { flag: 1, index } });
    const image = new Image();
    image.onload = async () => {
      const detail_img = {
        index,
        flag: 2,
        img: image.src,
        width: image.width,
        height: image.height,
        rotate: 0,
        multiple: 1,
        direction: 'x',
        marginL: 0,
        marginT: 0,
        o_width: image.width,
        o_height: image.height
      };
      await this.setData({ detail_img });
    };
    image.onerror = async () => {
      await this.setData({ detail_img: { flag: 3, index } });
    };
    image.src = src;
  };

  /**
   * 详情图片倍数变更
   */
  handleDetailImgMultiple = async (num) => {
    const detail_img = { ...this.state.detail_img };
    if (detail_img.flag === 2) {
      detail_img.multiple += num;
      detail_img.width = detail_img.o_width ? detail_img.o_width * detail_img.multiple : 0;
      detail_img.height = detail_img.o_height ? detail_img.o_height * detail_img.multiple : 0;
      if (detail_img.direction === 'y') {
        if (detail_img.width > detail_img.height) {
          detail_img.marginT = (detail_img.width - detail_img.height) / 2;
          detail_img.marginL = ~((detail_img.width - detail_img.height) / 2);
        } else if (detail_img.height > detail_img.width) {
          detail_img.marginT = ~((detail_img.height - detail_img.width) / 2);
          detail_img.marginL = (detail_img.height - detail_img.width) / 2;
        }
      }
      await this.setData({ detail_img });
    }
  };

  /**
   * 详情图片旋转变更
   */
  handleDetailImgRotate = async () => {
    const detail_img = { ...this.state.detail_img };
    if (detail_img.flag === 2) {
      detail_img.rotate += 90;
      detail_img.marginT = 0;
      detail_img.marginL = 0;
      if (detail_img.direction === 'x') {
        detail_img.direction = 'y';
        if (detail_img.width > detail_img.height) {
          detail_img.marginT = (detail_img.width - detail_img.height) / 2;
          detail_img.marginL = ~((detail_img.width - detail_img.height) / 2);
        } else if (detail_img.height > detail_img.width) {
          detail_img.marginT = ~((detail_img.height - detail_img.width) / 2);
          detail_img.marginL = (detail_img.height - detail_img.width) / 2;
        }
      } else {
        detail_img.direction = 'x';
      }
      await this.setData({ detail_img });
    }
  };

  /**
   * 详情图片显示图片变更
   */
  handleDetailImgPage = async (page) => {
    const detail_img = { ...this.state.detail_img }, detail_info = this.state.detail_info;
    let index = detail_img.index + page;
    if (index >= 0 && index < detail_info.img.length) {
      this.handleDetailImg(detail_info.img[index], index);
    }
  };

  render() {
    let { data_loading, auditList, selectedRowKeys, total, page, dataType, detail_visible, detail_info, detail_img } = this.state,
      tp = parseInt((total - 1) / 20);
    tp = (total - 1) % 20 === 0 ? tp : tp + 1;
    if (tp >= page) {
      tp = page;
    }
    let columns = [
      {
        title: '队员姓名',
        dataIndex: 'vname',
        key: 'vname',
        width: '10%'
      },
      {
        title: '被保人',
        dataIndex: 'ipsn_name',
        key: 'ipsn_name',
        width: '10%'
      },
      {
        title: '投保人',
        dataIndex: 'hldr_name',
        key: 'hldr_name',
        width: '10%'
      },
      {
        title: '保险名称',
        dataIndex: 'name',
        key: 'name',
        width: '15%'
      },
      {
        title: '保险单号',
        dataIndex: 'cntr_no',
        key: 'cntr_no',
        width: '10%'
      },
      {
        title: '承保公司',
        dataIndex: 'company',
        key: 'company',
        width: '10%'
      },
      {
        title: '有效期',
        dataIndex: 'expiry',
        key: 'expiry',
        width: '10%'
      },
      {
        title: '操作',
        dataIndex: 'id',
        key: 'id',
        width: dataType === '2' ? '10%' : '15%',
        render: (id, item) => {
          let reviewInfo = {
            id,
            uri: api.InsuraOrgAudit,
            id_key: 'id',
            source: () => this.dataSource(tp),
          };
          let disabled = selectedRowKeys.length > 1;
          return (
            <div style={{ textAlign: 'center' }}>
              <Button size="small" type="primary"
                onClick={() => this.handleOpenDetail(item)}>详情</Button>
              {
                dataType !== '2' ? (
                  <span>
                    <Popconfirm placement="bottom"
                      title="确定审核通过吗？"
                      cancelText="取消"
                      okText="确定"
                      onConfirm={async () => {
                        this.props.successReview(1, '', reviewInfo);
                      }}
                    >
                      <Button size="small" type="primary" disabled={disabled} style={{ marginLeft: 6 }}>通过</Button>
                    </Popconfirm>
                    <Button size="small" type="danger" onClick={() => {
                      this.props.failReview(reviewInfo);
                    }} disabled={disabled} ghost style={{ marginLeft: 6 }}>不通过</Button>
                  </span>
                ) : null
              }
            </div>
          );
        }
      }
    ],
      rowSelection = {
        selectedRowKeys,
        onChange: async (selectedRowKeys) => {
          await this.setData({ selectedRowKeys });
        }
      };
    let bodyHeight = document.body.clientHeight || document.body.offsetHeight || document.body.offsetHeight || 0;
    if (dataType === '2') {
      rowSelection = null;
      columns.splice(columns.length - 1, 0,

        {
          title: '审核员',
          dataIndex: 'team_header_audit',
          key: 'team_header_audit',
          width: '8%',
          render: (team_header_audit, { team_header_name, team_header_time, detail, status }) =>
            common.tableStatus(team_header_audit, team_header_name, team_header_time, detail, status, 1)
        },
        // {
        //   title: '二级审核',
        //   dataIndex: 'admin_audit',
        //   key: 'admin_audit',
        //   width: '8%',
        //   render: (admin_audit, { admin_name, admin_time, detail, status }) =>
        //     common.tableStatus(admin_audit, admin_name, admin_time, detail, status, 2)
        // },
        // {
        // title: '管理员审核', // 省管审核改为管理员审核
        // dataIndex: 'admin_audit',
        // key: 'admin_audit',
        // width: '15%',
        // render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit + '', admin_name, admin_time, detail)
        // }
      );
    }
    return (
      <div style={{ height: '100%' }}>
        <div>
          <span>审核状态： </span>
          <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
            await this.setData({ dataType: value });
            await this.dataSource();
          }}>
            <Option value="1">未审核</Option>
            <Option value="2">已审核</Option>
          </Select>
        </div>
        <Table columns={columns}
          locale={app.tbLocale(data_loading)}
          dataSource={auditList}
          loading={data_loading}
          scroll={{ y: 'calc(100% - 103px)' }}
          style={{ height: 'calc(100% - 52px)' }}
          rowSelection={rowSelection}
          pagination={false}
          footer={() => {
            return (
              <Row hidden={auditList.length === 0}>
                <Col span={10}>
                  <div hidden={dataType === '2'}>
                    <Checkbox
                      checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                      onChange={this.handleAllSel}>全选</Checkbox>
                    <Button style={{ margin: '0 20px' }} type="primary"
                      onClick={() => this.handlePLReview(1)}>通过</Button>
                    <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                  </div>
                </Col>
                <Col span={14} style={{ textAlign: 'right' }}>
                  <Pagination total={total} size="small" pageSize={20} current={page}
                    showTotal={(total) => `总数量：${total}`}
                    onChange={this.handlePageChange} />
                </Col>
              </Row>
            );
          }}
          size="small"
        />
        <Modal centered visible={detail_visible} width="80%" style={{ padding: 0 }}
          destroyOnClose={true} className="sx-insure-detail-modal"
          title={
            <Row>
              <Col span={8}>保险详情</Col>
              {
                detail_info.img ? (
                  <Col span={16} className="d-action">
                    <span>图片总数量 <span className="da-num">{detail_info.img.length}</span>张</span>
                    <span style={{ marginLeft: 20 }}>当前为第 <span
                      className="da-num">{detail_img.index + 1}</span>张</span>
                    <Button size="small" type="primary" style={{ marginLeft: 20 }}
                      onClick={() => this.handleDetailImgPage(-1)}
                      disabled={detail_img.index < 1}>上一张</Button>
                    <Button size="small" type="primary" style={{ marginLeft: 10 }}
                      onClick={() => this.handleDetailImgPage(1)}
                      disabled={detail_img.index >= detail_info.img.length - 1}>下一张</Button>
                    <Button size="small" type="primary" style={{ marginLeft: 10 }}
                      onClick={this.handleDetailImgRotate} disabled={detail_img.flag !== 2}>旋转</Button>
                    <Button size="small" type="primary" style={{ marginLeft: 10 }}
                      onClick={() => this.handleDetailImgMultiple(-0.5)}
                      disabled={detail_img.flag !== 2 || detail_img.multiple <= 0.5}>缩小</Button>
                    <Button size="small" type="primary" style={{ marginLeft: 10 }}
                      onClick={() => this.handleDetailImgMultiple(0.5)}
                      disabled={detail_img.flag !== 2 || detail_img.multiple >= 3}>放大</Button>
                  </Col>
                ) : null
              }
            </Row>
          }
          onCancel={() => this.setData({ detail_visible: false })}
          footer={
            dataType === '2' ? null : (
              <div style={{ textAlign: 'center' }}>
                <Popconfirm placement="bottom"
                  title="确定审核通过吗？"
                  cancelText="取消"
                  okText="确定"
                  onConfirm={() => {
                    this.props.successReview(1, '', {
                      id: detail_info.id,
                      uri: api.InsuraOrgAudit,
                      id_key: 'id',
                      source: async () => {
                        await this.setData({ detail_visible: false });
                        await this.dataSource(tp);
                      },
                    });
                  }}
                >
                  <Button type="primary" style={{ marginLeft: 6 }}>通过</Button>
                </Popconfirm>
                <Button type="danger" onClick={() => {
                  this.props.failReview({
                    id: detail_info.id,
                    uri: api.InsuraOrgAudit,
                    id_key: 'id',
                    source: async () => {
                      await this.setData({ detail_visible: false });
                      await this.dataSource(tp);
                    },
                  });
                }} ghost style={{ marginLeft: 6 }}>不通过</Button>
              </div>
            )
          }
        >
          <Row>
            <Col span={8} className="d-info">
              <div className="di-row">队员姓名：{detail_info.vname}</div>
              <div className="di-row">被保人：{detail_info.ipsn_name}</div>
              <div className="di-row">投保人：{detail_info.hldr_name}</div>
              <div className="di-row">保险名称：{detail_info.name}</div>
              <div className="di-row">保险类型：{detail_info.type_title}</div>
              <div className="di-row">保险单号：{detail_info.cntr_no}</div>
              <div className="di-row">承保公司：{detail_info.company}</div>
              <div className="di-row">有效期：{detail_info.expiry}</div>
              <div className="di-row">
                <Card title="管理员审核" size="small" style={{ marginRight: 20 }}>
                  {
                    detail_info.team_header_audit === '0' ? (<span>审核状态：未审核</span>) : (
                      <div>
                        <div className="di-row">审核状态：{detail_info.team_header_audit === '1' ? '已通过' : '不通过'}</div>
                        <div className="di-row">审核人：{detail_info.team_header_name}</div>
                        <div className="di-row">审核时间：{detail_info.team_header_time}</div>
                        {detail_info.team_header_audit === '2' ? (
                          <div className="di-row">审核原因：{detail_info.detail}</div>
                        ) : null}
                      </div>
                    )
                  }
                </Card>
              </div>
              {/* <div className="di-row">
                <Card title="管理员审核" size="small" style={{ marginRight: 20 }}>
                  {
                    detail_info.admin_audit === '0' ? (<span>未审核</span>) : (
                      <div>
                        <div className="di-row">{detail_info.admin_audit === '1' ? '已通过' : '不通过'}</div>
                        <div className="di-row">审核人：{detail_info.admin_name}</div>
                        <div className="di-row">审核时间：{detail_info.admin_time}</div>
                        {detail_info.admin_audit === '2' ? (
                          <div className="di-row">审核原因：{detail_info.detail}</div>
                        ) : null}
                      </div>
                    )
                  }
                </Card>
              </div> */}
            </Col>
            <Col span={16} className="d-img" style={{ height: bodyHeight - 168 }} id="detail-img">
              {
                detail_img.flag === 1 ? (
                  <div className="li-ts">正在加载图片...</div>
                ) : detail_img.flag === 2 ? (
                  <img src={detail_img.img} style={{
                    width: detail_img.width || 'auto',
                    height: detail_img.height || 'auto',
                    transform: `rotate(${detail_img.rotate}deg) `,
                    marginTop: detail_img.marginT,
                    marginLeft: detail_img.marginL
                  }} className="li-img" />
                ) : (
                  <div className="li-ts">图片加载失败...</div>
                )
              }
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

RIzzzzr.propTypes = {
  successReview: PropTypes.func.isRequired,   //审核通过处理
  failReview: PropTypes.func.isRequired,  //审核失败处理
};

export default RIzzzzr;



// WEBPACK FOOTER //
// ./src/routes/review/ReInsure/RIzzzzr.jsx